import React from 'react';
import * as uuid from 'uuid';
import { Box, Button, Text } from '@rsos/base-components';
import type { KeywordSet } from '@rsos/reduxDataStore';
import { useKeywordSetActions, useKeywordSets } from '@rsos/reduxDataStore';
import { useBooleanFlagValue } from '@rsos/utils/openFeature';
import { KeywordModal } from '../../components/KeywordModal/KeywordModal';
import { KeywordTable } from '../../components/KeywordTable/KeywordTable';
import { trackNewKeywordTopicEvent } from '../../tracking/KeywordAdminEvents';

const initialKeywordSet: KeywordSet = {
  name: '',
  id: '',
  keywords: [],
  speaker: 'caller',
  tier_id: 'tier-1',
};

export const Keywords = () => {
  const showReset = useBooleanFlagValue('reset_keyword_defaults', false);
  const { create, reset } = useKeywordSetActions();
  const { keywordSets } = useKeywordSets();
  const instrumentedCreate = (keywordSet: KeywordSet) => {
    trackNewKeywordTopicEvent(keywordSet);
    create(keywordSet);
  };
  return (
    <>
      <Text size="header" color="primaryText" fontWeight="bold" pb={16}>
        Keywords
      </Text>
      <Box horizontal mb={16} align="center">
        <Text color="primaryText">
          Harmony will watch each call, listening for keywords and who said
          them. When a keyword is detected, Harmony will highlight it, and alert
          your dispatchers based on the keyword's tier.
        </Text>
        <KeywordModal
          id="new"
          keywordSet={{ ...initialKeywordSet, id: uuid.v4() }}
          title="Add New Keyword Topic"
          save={instrumentedCreate}
        >
          {({ openModal }) => (
            <Button margin={0} onClick={openModal}>
              Add New Keyword
            </Button>
          )}
        </KeywordModal>
        {showReset && (
          <Button
            margin={0}
            ml="10px"
            onClick={reset}
            btnType="warning_tertiary"
          >
            Reset to Defaults
          </Button>
        )}
      </Box>
      <KeywordTable keywordSets={keywordSets} />
    </>
  );
};
